import React, { Component } from 'react';

  class FormErrors extends Component {

    render () {

      return(
        <div className='formErrors'>
          {Object.keys(this.props.formErrors).map((fieldName, i) => {
            if(this.props.formErrors[fieldName].length > 0){
              return (
                <p className="padding-xxs fontSize-l c-smoke--xd" key={i}>{fieldName} {this.props.formErrors[fieldName]}</p>
              )
            } else {
              return '';
            }
          })}
        </div>
      );

    }
  }

  export default FormErrors;



// WEBPACK FOOTER //
// ./src/views/components/form-errors/form-errors.js